<script lang="ts">
import { defineComponent } from 'vue';
import ProgressBar from '../../components/ProgressBar.vue';
import Tutorial from './Tutorial.vue';
import { mapActions, mapGetters } from 'vuex';
export default defineComponent({
  name: 'InteractiveHome',
  components: {
    'progress-bar': ProgressBar,
    tutorial: Tutorial
  },
  created () {
    window.addEventListener('resize', this.update);
    if (this.$route.query.type) {
      this.setFirstRoute(this.$route.query.type);
    }
    if (this.$route.query.version && this.$route.query.version === '2') {
      this.updateNewDay2ContentAddress('RofT');
    }
  },
  computed: {
    ...mapGetters([
      'finished',
      'level',
      'clearLevel1',
      'clearLevel2'
    ])
  },
  data () {
    return {
      isLoaded: false
    };
  },
  methods: {
    ...mapActions([
      'setFinish',
      'changeLevel',
      'setSuccess',
      'setFirstRoute',
      'updateNewDay2ContentAddress'
    ]),
    loaded (event: boolean) {
      this.isLoaded = event;
    },
    update () {
      const contentHeight = window.document.getElementById('app')?.offsetHeight + 'px';
      window.parent.postMessage({
        solutoHtmlInfo: { height: contentHeight }
      }, '*');
      window.parent.postMessage({
        solutoDynamicHtmlInfo: {
          height: contentHeight
        }
      }, '*');
    },
    scroll () {
      window.parent.postMessage(
        { solutoChangePage: true }, '*'
      );
    }
  },
  watch: {
    $route (to, from) {
      switch (from.path) {
        case '/interactive/rule-of-third/clear':
          if (to.path === '/interactive/rule-of-third/level' || to.path === '/interactive/rule-of-third/answer') {
            if (this.level === 1) {
              this.setSuccess({ setSuccess: false, level: 1 });
            } else {
              this.setSuccess({ setSuccess: false, level: 2 });
            }
          }
          break;
        case '/interactive/rule-of-third/setting':
          this.setFinish(false);
          break;
        case '/interactive/rule-of-third/level':
          if (to.path === '/interactive/rule-of-third' && this.level === 1) {
            this.changeLevel(0);
          }
          if (to.path === '/interactive/rule-of-third/clear' && !this.clearLevel2) {
            this.changeLevel(1);
          }
          break;
      }
    }
  }
});
</script>

<template>
  <div class="interactive">
      <progress-bar v-if="!finished"/>
      <tutorial v-if="level === 0" @load="update" @scroll="scroll"/>
      <router-view :key="$route.fullPath" @load="update" @scroll="scroll"></router-view>
  </div>
</template>

<style lang="scss" scoped>
</style>
